import { post } from '@/utils/network/axios-helper';

export interface IPointsConfig {
    desc: string;
    id: number;
    num: number;
    sub_type: number;
    type: number;
}

export interface IGetPointsConfigList_Res {
  list: IPointsConfig[];
}

export const getPointsConfigList = () => {
  return post<IGetPointsConfigList_Res>('/api/system/get-points-config-list', {});
};

export interface IGetRemainingPoints_Res {
  remaining_points: number;
}

export const getRemainingPoints = () => {
  return post<IGetRemainingPoints_Res>('/api/student/get-remaining-points', {});
};
